<template>
<div>
    <v-card flat>

        <v-card-text style="margin: 0; padding: 0">
            <v-layout justify-start wrap>
                <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader>
                        <v-subheader style="background: #f0f0f0"> Company Details <v-spacer></v-spacer>
                            <v-btn icon @click="editCompanyInfo=true">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-subheader>

                        <v-layout wrap>
                            <v-flex xs12>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.name}}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.registeredName}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            {{organisation.registrationNumber}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.vatNo}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px" v-if="organisation.vatNo">
                                            VAT Number
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>

                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Logo
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-img :src="organisation.logo"></v-img>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>

                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Icon
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-img :src="organisation.icon"></v-img>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Website
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon v-if="organisation.websiteUrl" color='green'>check</v-icon>
                                        <v-icon v-else color="red">cancel</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            FUP URL
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon v-if="organisation.fupUrl" color='green'>check</v-icon>
                                        <v-icon v-else color="red">cancel</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            T's & C's
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon v-if="organisation.termsAndConditionsLink" color='green'>check</v-icon>
                                        <v-icon v-else color="red">cancel</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-flex>

                        </v-layout>
                        <span v-if="organisation.description" style="padding: 5px; margin: 5px;">
                            <p style="padding: 5px; margin: 5px">{{ organisation.description }}</p>
                        </span>
                        
                    </v-list>
                    <v-list subheader two-line>
                        <v-list-tile :key="districtKey">
                            <v-list-tile-action>
                                <v-chip>{{organisation.organisationLicenseDistricts?organisation.organisationLicenseDistricts.length:0}}</v-chip>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                ICASA License Districts
                                </v-list-tile-title>
                            </v-list-tile-content>
                             <v-list-tile-action>
                               <v-btn icon @click="editDistrict=true">
                                   <v-icon>add</v-icon>
                               </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>

                    <v-list subheader two-line>
                        <v-subheader style="background: #f0f0f0"> Contact Details <v-spacer></v-spacer>
                            <v-btn icon @click="editContactInfo=true">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-subheader>

                        <v-layout wrap>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Accounts
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ organisation.billingEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Sales
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ organisation.salesEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Support
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ organisation.customerSupportEmail }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">call</v-icon> {{ organisation.customerSupportTelephone }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">whatsapp</v-icon> {{ organisation.customerSupportWhatsapp }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <span v-if="organisation.customerSupportDescription" style="padding: 5px; margin: 5px;">
                                    <p style="padding: 5px; margin: 5px">{{ organisation.customerSupportDescription }}</p>
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-list>
                </v-flex>
                <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader>
                        <v-subheader style="background: #f0f0f0"> Address Information <v-spacer></v-spacer>
                            <v-btn icon @click="editAddress()">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-layout wrap>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>

                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.physicalAddressLine1}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Address Line 1
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.physicalAddressLine2}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Address Line 2
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>

                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>

                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.physicalAddressLine3}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Address Line 3
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs6>
                                <v-list-tile>
                                    <v-list-tile-content>

                                        <v-list-tile-title style="font-size: 14px">
                                            {{organisation.physicalAddressLine4}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            Address Line 4
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs12>
                                <div style="width: 100%; height: 400px">
                                    <gmap-map :zoom="12" :options="{
                        disableDefaultUI: true
                    }" :center="
                      organisation.coordinates &&
                      organisation.coordinates != null
                        ? JSON.parse(organisation.coordinates)
                        : {
                 lng: 18.427059,
                lat: -33.919473
            }
                    " ref="mapRef" style="width: 100%; height: 400px; margin-top: 10px">
                                        <gmap-marker v-if="organisation.coordinates" :position="JSON.parse(organisation.coordinates)"></gmap-marker>
                                    </gmap-map>
                                </div>
                            </v-flex>

                        </v-layout>

                    </v-list>
                </v-flex>

                <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader dense>
                        <v-subheader style="background: #f0f0f0"> Theme <v-spacer></v-spacer>
                            <v-btn icon @click="editTheme=true">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-list-tile>
                            <v-list-tile-title style="font-size: 14px">
                                Primary Colour
                            </v-list-tile-title>
                            <v-list-tile-avatar :color="organisation.primaryColour">
                            </v-list-tile-avatar>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-title style="font-size: 14px">
                                Secondary Colour
                            </v-list-tile-title>
                            <v-list-tile-avatar :color="organisation.secondaryColour">
                            </v-list-tile-avatar>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-title style="font-size: 14px">
                                Navbar Colour
                            </v-list-tile-title>
                            <v-list-tile-avatar :color="organisation.navbarColour">
                            </v-list-tile-avatar>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-title style="font-size: 14px">
                                Navbar Text Colour
                            </v-list-tile-title>
                            <v-list-tile-avatar :color="organisation.navbarTextColour">
                            </v-list-tile-avatar>
                        </v-list-tile>
                        <div style="width: 100%" v-if="organisation.isPrimaryOrganisation">
                        <v-subheader style="background: #f0f0f0"> Accounting Settings <v-spacer></v-spacer>
                            <v-btn icon @click="editAccountingInfo=true">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-list-tile v-if="xeroUrl" :href="xeroUrl" @click="">
                            <v-list-tile-avatar>
                                <v-img contain src="xero_logo.svg"></v-img>
                            </v-list-tile-avatar>
                            <v-list-tile-sub-title>
                                Connect to Xero
                            </v-list-tile-sub-title>
                        </v-list-tile>
                        <div style="width: 100%">
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Billing Day
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    {{billingSettings.billingDay}}
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Bill Installation Fee to ISP
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-icon v-if="billingSettings.billIsp" color='green'>check</v-icon>
                                    <v-icon v-else color="red">cancel</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Aggregate Sales
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 12px">
                                        Condenses sales to one line item on invoice
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-icon v-if="billingSettings.aggregatePackageBilling" color='green'>check</v-icon>
                                    <v-icon v-else color="red">cancel</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Billing day included in calculations
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-icon v-if="billingSettings.includeBillingDay" color='green'>check</v-icon>
                                    <v-icon v-else color="red">cancel</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Installation Fee Configured
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-icon v-if="billingSettings.installAccountCode" color='green'>check</v-icon>
                                    <v-icon v-else color="red">cancel</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Setup Fee Configured
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-icon v-if="billingSettings.setupAccountCode" color='green'>check</v-icon>
                                    <v-icon v-else color="red">cancel</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                            </div>
                        </div>
                    </v-list>
                </v-flex>

                <!-- <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                <v-card flat>
                    <v-card-text>
                        <v-layout align-center wrap justify-center>
                            <v-flex xs6 sm4>
                                <v-autocomplete ref="tenantId" v-on:blur="$refs['tenantId'].blur()" v-if="billingSettings.accountingSystem == 'Xero'&&accountingCompanies.length>0" :items="accountingCompanies" clearable label="Accounting Company" item-text="tenantName" item-value="tenantId" v-model="billingSettings.accountingId"></v-autocomplete>
                                <v-btn round color="primary" class="white--text" v-else-if="xeroUrl" :href="xeroUrl">Connect to Xero</v-btn>
                                <v-autocomplete v-if="billingSettings.accountingSystem == 'Xero'&&taxTypes.length>0" :items="taxTypes" clearable label="Tax Type" item-text="name" item-value="taxType" v-model="billingSettings.taxType"></v-autocomplete>
                                <v-select label="Billing Day" v-model="billingSettings.billingDay" :items="availableBillingDays"></v-select>
                                <v-checkbox label="Bill ISP Install Fees" v-model="billingSettings.billIsp"></v-checkbox>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2">
                                <v-autocomplete ref="packageAccount" v-on:blur="$refs['packageAccount'].blur()" v-if="billingSettings.aggregatePackageBilling" v-model="billingSettings.packageAccount" :items="accountingAccounts" label="Aggregate package sales account" item-text="name" item-value="id" clearable></v-autocomplete>
                                <v-checkbox label="Include Billing day in calculations" v-model="billingSettings.includeBillingDay"></v-checkbox>
                                <v-checkbox label="Aggregate packages into one line item" v-model="billingSettings.aggregatePackageBilling"></v-checkbox>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2">
                                <v-select @change="billingSettings.installAccountCode = null" :items="['Item', 'Account']" label="Install Billing Type" v-model="billingSettings.installFeeType"></v-select>
                            </v-flex>
                            
                            <v-flex xs6 sm4 class="ml-2" v-if="billingSettings.accountingSystem == 'Xero'">
                                <v-autocomplete ref="installFeeType" v-on:blur="$refs['installFeeType'].blur()" v-if="billingSettings.installFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Install Fees Account" v-model="billingSettings.installAccountCode"></v-autocomplete>
                                <v-autocomplete ref="installFeeType" v-on:blur="$refs['installFeeType'].blur()" v-else-if="billingSettings.installFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Install Fees Item" v-model="billingSettings.installAccountCode"></v-autocomplete>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2">
                                <v-select @change="billingSettings.setupAccountCode = null" :items="['Item', 'Account']" label="Setup Billing Type" v-model="billingSettings.setupFeeType"></v-select>
                            </v-flex>
                           
                            <v-flex xs6 sm4 class="ml-2" v-if="billingSettings.accountingSystem == 'Xero'">
                                <v-autocomplete ref="setupFeeType" v-on:blur="$refs['setupFeeType'].blur()" v-if="billingSettings.setupFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Setup/Activation Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                                <v-autocomplete ref="setupFeeType" v-on:blur="$refs['setupFeeType'].blur()" v-else-if="billingSettings.setupFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Setup/Activation Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
                </v-flex> -->

            </v-layout>
        </v-card-text>
    </v-card>

    <v-dialog v-model="editCompanyInfo" width="750px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Company Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="editCompanyInfo=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center>
                    <v-flex xs5 class="mx-1">
                        <v-text-field box v-model="organisation.name" label="Name*"></v-text-field>
                        <v-text-field box v-model="organisation.registeredName" label="Registered Name"></v-text-field>
                        <v-text-field box v-model="organisation.registrationNumber" label="Registration Number"></v-text-field>
                        <v-text-field box v-model="organisation.vatNo" label="VAT Number"></v-text-field>
                        <v-text-field box v-model="organisation.websiteUrl" label="Website"></v-text-field>

                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-textarea rows="1" auto-grow box v-model="organisation.description" label="Company Description"></v-textarea>
                        <v-text-field box v-model="organisation.fupUrl" label="Fair Usage Policy URL"></v-text-field>
                        <v-text-field box v-model="organisation.termsAndConditionsLink" label="T's & C's URL"></v-text-field>
                        <v-list>
                            <v-list-tile>
                                <v-list-tile-action :key="key">
                                    <v-img :src="organisation.logo"></v-img>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" class="ml-2">
                                        Logo
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-btn icon v-if="organisation.logo" @click="$refs.uploader.click()">
                                        <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <v-btn icon v-else @click="$refs.uploader.click()">
                                        <v-icon small>add</v-icon>
                                    </v-btn>
                                    <input ref="uploader" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'logo')" />
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-action :key="key">
                                    <v-img :src="organisation.icon"></v-img>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" class="ml-2">
                                        Icon
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-btn icon v-if="organisation.icon" @click="$refs.uploaderIcon.click()">
                                        <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <v-btn icon v-else @click="$refs.uploaderIcon.click()">
                                        <v-icon small>add</v-icon>
                                    </v-btn>
                                    <input ref="uploaderIcon" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'icon')" />
                                </v-list-tile-action>

                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn flat color="primary" @click="editCompanyInfo=false, updateOrganisation()">Done</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editContactInfo" width="750px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Contact Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="editContactInfo=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center>
                    <v-flex xs5 class="mx-1">
                        <h3>Accounts</h3>
                        <v-text-field prepend-icon="email" box v-model="organisation.billingEmailAddress" label="Email Address"></v-text-field>
                        <v-text-field prepend-icon="call" box v-model="organisation.billingContactNumber" label="Contact Number"></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <h3>Sales</h3>
                        <v-text-field prepend-icon="email" box v-model="organisation.salesEmailAddress" label="Email Address"></v-text-field>
                        <v-text-field prepend-icon="call" box v-model="organisation.salesContactNumber" label="Contact Number"></v-text-field>
                    </v-flex>
                    <v-flex xs10 class="mx-1">
                        <h3>Support</h3>
                        <v-layout wrap>
                            <v-flex xs6>
                                <v-text-field prepend-icon="email" box v-model="organisation.customerSupportEmail" label="Email Address"></v-text-field>

                            </v-flex>
                            <v-flex xs6>
                                <v-text-field prepend-icon="call" box v-model="organisation.customerSupportTelephone" label="Contact Number"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field prepend-icon="whatsapp" box v-model="organisation.customerSupportWhatsapp" label="Whatsapp Number"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-textarea class="ml-2" box label="Description (e.g. support hours)" v-model="organisation.customerSupportDescription"></v-textarea>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                                <v-btn flat color="primary" @click="editCompanyInfo=false, updateOrganisation()">Done</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editAddressInformation" width="1000px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Address Information</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="editAddressInformation=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center align-center>
                    <v-flex xs5 class="mx-1">
                        <v-text-field label="Address Line 1" box v-model="organisation.physicalAddressLine1"></v-text-field>
                        <v-text-field label="Address Line 2" box v-model="organisation.physicalAddressLine2"></v-text-field>
                        <v-text-field label="Address Line 3" box v-model="organisation.physicalAddressLine3"></v-text-field>
                        <v-text-field label="Address Line 4" box v-model="organisation.physicalAddressLine4"></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-text-field outlined id="pac-input" clearable placeholder="Find Address"></v-text-field>
                        <gmap-map :key="key" :zoom="12" :options="{
                        disableDefaultUI: true
                    }" @click="getAddressData($event)" :center="
                      organisation.coordinates &&
                      organisation.coordinates != null
                        ? JSON.parse(organisation.coordinates)
                        : {
                 lng: 18.427059,
                lat: -33.919473
            }
                    " ref="mapRef" style="width: 450px; height: 250px">
                            <gmap-marker v-if="organisation.coordinates" :position="JSON.parse(organisation.coordinates)"></gmap-marker>
                        </gmap-map>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn flat color="primary" @click="editAddressInformation=false, updateOrganisation()">Done</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editTheme" width="1000px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Theme</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="editTheme=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center align-center>
                    <v-flex xs5 class="mx-1 text-xs-center">
                        <v-card flat>
                            <v-card-title style="font-size: 18px; font-weight:bold">
                                Primary Colour
                            </v-card-title>
                            <v-card-text>
                                <chromepicker v-model="organisation.primaryColour" />

                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-card flat>
                            <v-card-title style="font-size: 18px; font-weight:bold">
                                Secondary Colour
                            </v-card-title>
                            <v-card-text>
                                <chromepicker v-model="organisation.secondaryColour" />

                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-card flat>
                            <v-card-title style="font-size: 18px; font-weight:bold">
                                Navigation Drawer Colour
                            </v-card-title>
                            <v-card-text>
                                <chromepicker v-model="organisation.navbarColour" />

                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-card flat>
                            <v-card-title style="font-size: 18px; font-weight:bold">
                                Navigation Drawer Text Colour
                            </v-card-title>
                            <v-card-text>
                                <chromepicker v-model="organisation.navbarTextColour" />

                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn flat color="primary" @click="editTheme=false, updateOrganisation()">Done</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editAccountingInfo" width="900px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Accounting Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="editAccountingInfo=false, updateBillingSettings()">Done</v-btn>
                <v-btn flat @click="editAccountingInfo=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center>
                    <v-flex xs5 mx-1>
                        <v-list dense>
                              <v-autocomplete dense style="font-size: 12px" box ref="tenantId" v-on:blur="$refs['tenantId'].blur()" v-if="accountingCompanies.length>0" :items="accountingCompanies" clearable label="Accounting Company" item-text="tenantName" item-value="tenantId" v-model="billingSettings.accountingId"></v-autocomplete>
                                <v-autocomplete dense style="font-size: 12px" box ref="taxType" v-on:blur="$refs['taxType'].blur()" v-if="taxTypes.length>0" :items="taxTypes" clearable label="Tax Type" item-text="name" item-value="taxType" v-model="billingSettings.taxType"></v-autocomplete>

                                <v-select style="font-size: 12px" dense :items="availableBillingDays" label="Billing Day" box v-model="billingSettings.billingDay"></v-select>
                            <v-list-tile>
                              
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Billing day included in calculations
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-checkbox v-model="billingSettings.includeBillingDay"></v-checkbox>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>

                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-list dense>

                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Aggregate Sales
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 12px">
                                        Condenses sales to one line item on invoice
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px">
                                    <v-checkbox v-model="billingSettings.aggregatePackageBilling"></v-checkbox>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-subheader style="background: #f0f0f0"> Installation Fee
                            </v-subheader>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px">
                                        Bill Installation Fee to ISP
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="font-size: 14px" class="text-xs-center">
                                    <v-checkbox hide-details v-model="billingSettings.billIsp"></v-checkbox>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-layout class="mt-1">
                                <v-flex xs6 px-1>
                                    <v-select dense style="font-size: 12px" @change="billingSettings.installAccountCode = null" :items="['Item', 'Account']" label="Install Billing Type" v-model="billingSettings.installFeeType"></v-select>

                                </v-flex>
                                <v-flex xs6 px-1>
                                    <v-autocomplete dense style="font-size: 12px" ref="installFeeType" v-on:blur="$refs['installFeeType'].blur()" v-if="billingSettings.installFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Install Fee Account" v-model="billingSettings.installAccountCode"></v-autocomplete>
                                    <v-autocomplete dense style="font-size: 12px" ref="installFeeType" v-on:blur="$refs['installFeeType'].blur()" v-else-if="billingSettings.installFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Install Fee Item" v-model="billingSettings.installAccountCode"></v-autocomplete>
                                </v-flex>
                            </v-layout>

                            <v-subheader style="background: #f0f0f0"> Setup Fee
                            </v-subheader>
                            <v-layout class="mt-1">
                                <v-flex xs6 px-1>
                                    <v-select dense style="font-size: 12px" @change="billingSettings.setupAccountCode = null" :items="['Item', 'Account']" label="Setup Fee Billing Type" v-model="billingSettings.setupFeeType"></v-select>

                                </v-flex>
                                <v-flex xs6 px-1>
                                    <v-autocomplete dense style="font-size: 12px" ref="setupAccountCode" v-on:blur="$refs['setupAccountCode'].blur()" v-if="billingSettings.installFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Setup Fee Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                                    <v-autocomplete dense style="font-size: 12px" ref="setupAccountCode" v-on:blur="$refs['setupAccountCode'].blur()" v-else-if="billingSettings.installFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Setup Fee Item" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                                </v-flex>
                            </v-layout>

                        </v-list>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editDistrict" width="900px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>ICASA Districts</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="saveDistricts">Done</v-btn>
                <v-btn flat @click="editDistrict=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
              <v-data-table select-all item-key="id" :items="districts" :headers="districtHeaders" v-model="selectedDistricts">
                  <template v-slot:items="props">
                      <td>
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                   <td>{{ props.item.name }}
                    </td>
                     <td>{{ props.item.region.name }}
                    </td>
                  </template>
              </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
import {
    gmapApi,
    Map
} from "vue2-google-maps";
import {
    Chrome
} from "vue-color";
export default {
    props: ['organisation', 'accountingCompanies', 'accountingItems', 'accountingAccounts', 'billingSettings', 'taxTypes', 'xeroUrl'],
    components: {
        chromepicker: Chrome,
        "gmap-map": Map,
    },
    data() {
        return {
            addressSearch: '',
            districts: [],
            districtKey: 0,
            selectedDistricts: [],
            districtHeaders: [
                {
                    text: "Name",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Region",
                    align: "center",
                    value: "region.name"
                },
            ],
            editAddressInformation: false,
            editAccountingInfo: false,
            editCompanyInfo: false,
            editContactInfo: false,
            editDistrict: false,
            editTheme: false,
            key: 0,
            availableBillingDays: ['1st', '7th', '15th', '25th'],
            invoiceDueDate: ['Same Day', '7 Days after Invoice Date', '14 Days after invoice date', 'Last Day of the Month'],
            // Map Data
            center: {
                lat: 18.427059,
                lng: -33.919473
            },
            geocoder: null,
            infoWindowContent: {},
            key: 0,
            infoWindowPos: {
                lat: 0,
                lng: 0,
            },
            infoWinOpen: false,
            zoom: 15,
        }
    },
    computed: {
        google: gmapApi,
    },
    watch: {
        'organisation.id': {
            immediate: true,
            handler(val){
                if(val){
                    this.getDistricts()
                }
            }
        },
        editDistrict(val){
            if(val){
                this.selectedDistricts = this.organisation.organisationLicenseDistricts.map(y=>y.licenseDistrict)
                // this.districts.forEach(x=>{
                //     x.selected = this.organisation.organisationLicenseDistricts.map(y=>y.licenseDistrictId).includes(x.id)
                // })
            }
        }
    },
    created(){
        
    },
    methods: {
        editAddress() {
            this.editAddressInformation = true
            setTimeout(() => {
                this.$refs.mapRef.$mapPromise.then(() => {
                    this.initMapAutocomplete();
                });
            }, 2000)
        },
        getDistricts(){
            Api().get('/licenseDistricts').then(res=>{
                this.districts = res.data
            })
            Api().get('/organisationLicenseDistrict').then(res=>{
                this.organisation.organisationLicenseDistricts = res.data
                this.districtKey ++
            })
        },
        async initMapAutocomplete() {
            console.log('Autocomplete initiated')
            const input = document.getElementById("pac-input");
            const autocomplete = new this.google.maps.places.Autocomplete(input, {});
            this.google.maps.event.addListener(
                autocomplete,
                "place_changed",
                async () => {
                    const place = autocomplete.getPlace();
                    this.organisation.coordinates = JSON.stringify({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    });
                    this.center = this.organisation.coordinates
                    this.key++
                }
            );
        },
        getAddressData: async function (addressData, placeResultData, id) {
            this.organisation.coordinates = JSON.stringify({
                lat: addressData.latLng.lat(),
                lng: addressData.latLng.lng(),
            });
            this.center = this.organisation.coordinates
        },
        updateOrganisation() {
            Api()
                .put("/organisation/" + this.$store.state.currentOrg.org.id,
                    this.organisation).then(async () => {
                    // let organisations = this.$store.state.organisations;
                    // let currentOrgId = this.$store.state.currentOrg.org.id;
                    // let changedOrg = organisations.filter(function (el) {
                    //     return el.org.id === currentOrgId;
                    // });
                    // let index = organisations.indexOf(changedOrg[0]);
                    // let currentOrg = {
                    //     userType: this.$store.state.currentOrg.userType,
                    //     org: this.organisation
                    // };
                    // organisations[index] = currentOrg;
                    // await this.$store.dispatch("setOrganisations", organisations);
                    // await this.$store.dispatch("setCurrentOrg", organisations[index]);
                })
        },
        updateBillingSettings() {
            Api()
                .put("/organisation/" + this.$store.state.currentOrg.org.id,
                    this.billingSettings).then(async () => {
                })
        },
        selectFile(event, type) {
            this.file = event.srcElement.files[0];
            console.log(this.file)
            if(this.file.size > 1048576){
       alert("This file exceeds the maximum size of 1Mb, please select another file.");
       this.file = null;
            } else {
            this.readFile(this.file, type);
            }
        },
        async readFile(file, type) {
            var reader = await new FileReader();
            await reader.readAsDataURL(file);
            reader.onload = () => {
                if (type == 'logo') {
                    this.setResultLogo(reader.result);
                } else if (type == 'packageLogo') {
                    this.setResultPackageLogo(reader.result)
                } else if (type == 'modalImage') {
                    this.setResultPackageModalImage(reader.result)
                } else if (type == 'icon') {
                    this.setResultIcon(reader.result)
                } else if (type == 'orderPageLogo') {
                    this.setResultOrderPageLogo(reader.result)
                }
            };
            reader.onerror = function () {
                console.log("there are some problems");
            };
        },
        setResultOrderPageLogo(result) {
            this.awsUpload(result, 'orderPageLogo')
            this.organisation.orderPageLogo = result;
            this.key += 1;
        },
        setResultLogo(result) {
            this.awsUpload(result, 'logo')
            this.organisation.logo = result;
            this.key += 1;
        },
        setResultIcon(result) {
            this.awsUpload(result, 'icon')
            this.organisation.icon = result;
            this.key += 1;
        },
        setResultPackageLogo(result) {
            this.awsUpload(result, 'packageLogo')
            this.organisation.packageCardLogo = result;
            this.key += 1;
        },
        setResultPackageModalImage(result) {
            this.awsUpload(result, 'modalImage')
            this.organisation.packageCardModalImage = result;
            this.key += 1;
        },
        awsUpload(data, type) {
            Api()
                .post("/aws/s3/uploadLogo", {
                    organisationId: this.$store.state.currentOrg.org.id,
                    type: type,
                    data: data
                })
                .then((res) => {
                    console.log(res.data);
                });
        },
        async createLicenseDistrict(obj){
            await Api().post('/organisationLicenseDistrict', obj)
        },
        async updateLicenseDistrict(obj){
            await Api().put('/organisationLicenseDistrict/'+obj.id, obj)
        },
        async saveDistricts(){
            this.editDistrict = false
            let selected = this.selectedDistricts
            console.log(this.selectedDistricts)
            console.log(this.organisation)
            let create = selected.filter(x=>!this.organisation.organisationLicenseDistricts.map(y=>y.licenseDistrictId).includes(x.id))
            let remove = this.organisation.organisationLicenseDistricts.filter(x=>!selected.map(y=>y.id).includes(x.licenseDistrictId))
            console.log('create', create)
            console.log('remove', remove)
            for(let i=0;i<create.length;i++){
                await this.createLicenseDistrict({licenseDistrictId: create[i].id})
            }
            for(let i=0;i<remove.length;i++){
                await this.updateLicenseDistrict({id: remove[i].id, isActive: false, isDeleted: true})
            }
            this.selectedDistricts = []
            this.getDistricts()

        }
    }

}
</script>
